export class ReportMapEntity {
  private source: string = '';
  private centerpoint: { latitude: number; longitude: number };
  private name: string;
  private type: string;
  private icon: string;
  private timestamp: number;

  constructor(
    name: string,
    type: string,
    latitude: number,
    longitude: number,
    icon: string,
    timestamp: number
  ) {
    this.name = name;
    this.type = type;
    this.centerpoint = { latitude, longitude };
    this.icon = icon;
    this.timestamp = timestamp;
  }

  setSource(source: string): void {
    this.source = source;
  }

  getSource(): string {
    return this.source;
  }

  getCenterpoint(): { latitude: number; longitude: number } {
    return this.centerpoint;
  }

  getName(): string {
    return this.name;
  }

  getType(): string {
    return this.type;
  }

  getIcon(): string {
    return this.icon;
  }

  getTimestamp(): number {
    return this.timestamp;
  }
} 